import React from 'react';
import { FIELD_TABS } from '../constants';
import { useMultiReports } from '../MultiReportsContext';

export function TabNavigation() {
  const { activeFieldTab, setActiveFieldTab } = useMultiReports();

  return (
    <div className="bg-white/85 backdrop-blur-xl p-2 rounded-2xl border border-indigo-100/60 shadow-sm">
      <div className="flex flex-wrap gap-2">
        {FIELD_TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveFieldTab(tab.id)}
            className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-180 ease-out ${
              activeFieldTab === tab.id 
                ? 'text-white shadow-[0_4px_12px_rgba(79,70,229,0.30)]' 
                : 'bg-slate-50 text-gray-700 hover:bg-indigo-50/60'
            }`}
            style={activeFieldTab === tab.id ? { background: 'linear-gradient(135deg, #4F46E5 0%, #6D28D9 100%)' } : {}}
            data-testid={`tab-${tab.id}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
